<app-nav></app-nav>
<app-top-header [pageTitle]="'page.other'"></app-top-header>

<div class="ParentSectionSection_Components_HTally">
  <div class="Body_ParentSectionSection_Components_HTally">
    <div class="InnerPart_Body_Renter_Htally">
      <div class="Parent_ActivityList_Dashboard TabsSection">
        <div class="InnerBodyOfComponents">
          <div class="TabsHeader">
            <div class="RemainActivityList_Tab_Button">
              <button type="button" (click)="selectTab('Employee')" [class.active]="activeTab === 'Employee'">{{ 'user.employeeTab' | t:'Subuser' }}<span></span></button>
              <button *ngIf="isRoleOne" type="button" (click)="selectTab('Package')" [class.active]="activeTab === 'Package'">{{ 'user.packageTab' | t:'Package' }}<span></span></button>
              <button *ngIf="isRoleOne" type="button" (click)="selectTab('AssignPackage')" [class.active]="activeTab === 'AssignPackage'">{{ 'user.assignPackageTab' | t:'Assign Package' }}<span></span></button>
            </div>

            <div class="TabsActions">
              <button *ngIf="activeTab === 'Employee' || activeTab === 'AssignPackage'" class="FilterBTN" [class.active-filter]="isFilterActive()" type="button" (click)="toggleFilter()">
                {{ 'common.filter' | t:'Filter' }}
              </button>
              <button *ngIf="activeTab === 'Employee' || activeTab === 'Package' || activeTab === 'AssignPackage'" class="PositiveBTN" type="button" (click)="activeTab === 'Employee' ? openNewEmployee() : (activeTab === 'Package' ? openNewPackage() : openNewAssignPackage())">
                {{ activeTab === 'Employee'
                  ? ('user.addEmployee' | t:'Add Subuser')
                  : (activeTab === 'Package' ? ('package.addButton' | t:'Add Package') : ('assignPackage.addButton' | t:'Add Assign Package')) }}
              </button>
            </div>
          </div>

          <div *ngIf="activeTab === 'Employee'" class="RemainActivityList_tab_content">
            <app-employee-list></app-employee-list>
          </div>
          <div *ngIf="activeTab === 'Package' && isRoleOne" class="RemainActivityList_tab_content">
            <app-package-list></app-package-list>
          </div>
          <div *ngIf="activeTab === 'AssignPackage' && isRoleOne" class="RemainActivityList_tab_content">
            <app-assign-package></app-assign-package>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-add-edit-employee
  *ngIf="showNewEmployee"
  [mode]="'create'"
  (close)="closeNewEmployee()"
  (save)="handleEmployeeSave($event)"
></app-add-edit-employee>

<app-add-edit-package
  *ngIf="showNewPackage"
  [mode]="'create'"
  (close)="closeNewPackage()"
  (save)="handlePackageSave($event)"
></app-add-edit-package>

<app-filter-modal
  *ngIf="showFilter && (activeTab === 'Employee' || activeTab === 'AssignPackage')"
  [fields]="activeTab === 'Employee' ? employeeFilterFields : assignPackageFilterFields"
  [value]="activeTab === 'Employee' ? employeeFilterValues : assignPackageFilterValues"
  (apply)="applyFilters($event[0], $event[1])"
  (reset)="resetFilters()"
  (close)="toggleFilter()"
></app-filter-modal>
